<template>
	<div class="grid-content">
		<div class="grid-content-title">
			<div class="name">管理员</div>
			<div class="right">
				<el-button size="mini" @click="refreshAdmin">
					<i class="el-icon-refresh"></i>
					<span>刷新</span>
				</el-button>
			</div>
		</div>
		<div class="grid-content-operate">
			<el-button type="primary" size="small" @click="addAdmin">添加管理员</el-button>
		</div>
		<div class="grid-content-list admin">
			<div class="common-table">
				<table class="header">
					<colgroup>
						<col width="4%">
						<col width="15%">
						<col>
						<col width="16%">
					</colgroup>
					<thead>
						<tr>
							<th>
								<el-checkbox></el-checkbox>
							</th>
							<th>管理员信息</th>
							<th>权限</th>
							<th>操作</th>
						</tr>
					</thead>
				</table>
				<table class="body" v-loading="(loading && total>0)?true:false">
					<colgroup>
						<col width="4%">
						<col width="15%">
						<col>
						<col width="16%">
					</colgroup>
					<thead>
						<template v-for="(item,index) in list">
							<tr class="separation-row">
								<td colspan="9"></td>
							</tr>
							<tr class="content-row">
								<td>
									<div style="display: flex;align-items: center;justify-content: center;">
										<el-checkbox></el-checkbox>
									</div>
								</td>
								<td>
									<div class="user">
										<img v-if="item.head" :src="item.head" class="avatar">
										<img v-else src="../../assets/admin_head.png" class="avatar">
										<div class="info">
											<div class="name">
												{{item.name?item.name:'null'}}
											</div>
											<div class="phone">{{item.phone}}</div>
										</div>
										<div v-if="item.super==1" class="grade super">
											<div class="bg"></div>
											<div class="text">超管</div>
										</div>
										<div v-else class="grade">
											<div class="bg"></div>
											<div class="text">普通</div>
										</div>
									</div>
								</td>
								<td>
									<div class="power">
										<el-tag v-if="item.super==1" type="info" size="mini">所有权限</el-tag>
										<template v-else>
											<template v-for="(p,i) in item.power">
												<el-tag v-if="p=='order_dispatch'" type="info" size="mini">订单调度</el-tag>
												<el-tag v-if="p=='driver_finance'" type="info" size="mini">司机财务
												</el-tag>
											</template>
										</template>
									</div>
								</td>
								<td>
									<div class="operate">
										<el-button plain size="mini" @click="editAdmin(index)"
											:disabled="(item.edit)?false:true">编辑
										</el-button>
										<el-button type="danger" plain size="mini" @click="delAdmin(item.id)"
											:disabled="(item.super==1)?true:false">
											停用
										</el-button>
									</div>
								</td>
							</tr>
						</template>
					</thead>
				</table>
			</div>
			<div v-if="loading && total<=0" style="min-height: 20rem;" v-loading="loading"></div>
			<div v-if="total>0" class="page">
				<el-pagination background layout="total, prev, pager, next" :current-page.sync="page" :total="total"
					@current-change="pageAdmin">
				</el-pagination>
			</div>
			<el-empty v-if="!loading && total<=0" style="height: 20rem;" description="暂无管理员数据" :image-size="100">
			</el-empty>
		</div>
		<el-drawer :title="drawer_info.form.mode=='edit'?'编辑管理员':'添加管理员'" :visible.sync="drawer_info.show">
			<div class="drawer admin">
				<div class="content">
					<el-form :model="drawer_info.form" :rules="drawer_info.rules" label-position="left"
						label-width="100px" ref="adminInfoForm" size="small" style="margin-top: 1.25rem;">
						<el-form-item label="真实姓名" prop="name">
							<el-input v-model="drawer_info.form.name" style="width: 10rem;" placeholder="请输入管理员姓名"
								clearable>
							</el-input>
						</el-form-item>
						<el-form-item label="手机号码" prop="phone">
							<el-input v-model="drawer_info.form.phone" style="width: 12rem;" placeholder="请输入管理员手机号码"
								clearable>
							</el-input>
						</el-form-item>
						<el-form-item label="权限">
							<el-checkbox-group v-model="drawer_info.form.power">
								<el-checkbox v-for="(po,ins) in drawer_info.power" :label="po.name" :key="ins"
									:disabled="drawer_info.form.super==1?true:false">
									{{po.label}}
								</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
					</el-form>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" :loading="drawer_info.loading" @click="submitInfoAdmin">
						{{drawer_info.form.mode == "edit"?"提交保存":"确认添加"}}
					</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: true,
				query: {},
				page: 1,
				total: 0,
				list: [],
				drawer_info: {
					show: false,
					loading: false,
					rules: {
						name: [{
								required: true,
								message: '请输入管理员真实姓名'
							},
							{
								validator(rule, value, callback) {
									const reg = /^[\u4e00-\u9fa5]+$/
									if (value.length < 100 && reg.test(value)) {
										callback()
									} else {
										return callback(new Error('请输入正确的管理员姓名'))
									}
								},
								trigger: 'blur'
							}
						],
						phone: [{
								required: true,
								message: '请输入手机号码'
							},
							{
								validator(rule, value, callback) {
									const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
									if (reg.test(value)) {
										callback()
									} else {
										return callback(new Error('请输入正确的手机号码'))
									}
								},
								trigger: 'blur'
							}
						],
					},
					power: [{
							name: "order_add",
							label: '创建订单'
						},
						{
							name: "order_dispatch",
							label: '调度订单'
						},
						{
							name: "driver_finance",
							label: '司机财务'
						}
					],
					form: {
						mode: "add",
						id: 0,
						name: "",
						phone: "",
						super: 0,
						power: []
					}
				}
			};
		},
		created() {
			this.postAdmin();
		},
		methods: {
			addAdmin() {
				const that = this;
				that.drawer_info.form = that.$options.data().drawer_info.form;
				that.drawer_info.show = true;
				that.drawer_info.loading = false;
				if (that.$refs.adminInfoForm != undefined) {
					that.$refs.adminInfoForm.resetFields();
				}
			},
			editAdmin(index) {
				const that = this;
				var formData = {
					mode: "edit",
					id: that.list[index].id,
					name: that.list[index].name,
					phone: that.list[index].phone,
					super: that.list[index].super,
					power: that.list[index].power
				};
				that.drawer_info.show = true;
				that.drawer_info.loading = false;
				//如果是超管，则全选权限
				if (that.list[index].super == 1) {
					var power = [];
					that.drawer_info.power.forEach(function(a, b) {
						power.push(a.name);
					});
					formData.power = power;
				}
				that.$set(that.drawer_info, 'form', formData);
				if (that.$refs.adminInfoForm != undefined) {
					that.$refs.adminInfoForm.resetFields();
				}
			},
			submitInfoAdmin() {
				const that = this;
				that.$refs.adminInfoForm.validate((valid) => {
					if (valid) {
						that.drawer_info.loading = true;
						that.$post('operateAdmin', that.drawer_info.form).then(res => {
							that.drawer_info.show = false;
							that.$message.success("操作成功");
							setTimeout(function() {
								that.pageAdmin(1);
							}, 1000);
						}).catch(e => {
							that.drawer_info.loading = false;
							that.$alert((e != undefined && e.message != undefined && e.message) ? e
								.message :
								"未知错误，请重试", '提示', {
									type: 'error',
									confirmButtonText: '确定'
								});
						});
					} else {
						return false;
					}
				});
				console.log(this.drawer_info.form)
			},
			refreshAdmin() {
				this.pageAdmin(1);
			},
			pageAdmin(e) {
				this.page = e;
				this.postAdmin(this.query);
			},
			postAdmin(query = {}) {
				const that = this;
				that.loading = true;
				that.$post('operateAdmin', {
					query: query,
					page: that.page
				}).then(res => {
					setTimeout(function() {
						that.loading = false;
						that.total = res.data.total;
						res.data.list.map((item) => {
							item.checked = false;
							return item;
						});
						that.list = res.data.list;
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.admin .user {
		display: flex;
		align-items: center;
		padding: 10px;
		position: relative;
	}

	.admin .user .avatar {
		width: 2.5rem;
		height: 2.5rem;
		border-radius: 0.375rem;
	}

	.admin .user .info {
		margin-left: 0.3125rem;
	}

	.admin .user .info .name {
		font-size: 0.875rem;
		font-weight: bold;
		color: #576b95
	}

	.admin .user .info .phone {
		color: #666;
		margin-top: 0.3rem;
		font-size: 0.75rem;
	}

	.admin .user .grade {
		position: absolute;
		top: -0.125rem;
		left: -0.125rem;
	}

	.admin .user .grade .bg {
		border-left: 2.5rem solid #7b7e93;
		border-bottom: 2.5rem solid transparent;
	}

	.admin .user .grade .text {
		position: absolute;
		top: 0.3125rem;
		left: 0;
		color: white;
		font-weight: bold;
		text-align: center;
		font-size: 0.75rem;
		transform: scale(.8);
		transform: rotate(-45deg);
	}

	.admin .user .grade.super .bg {
		border-left: 2.5rem solid #ff6600;
	}

	.admin .power,
	.admin .operate {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.875rem;
	}

	.admin .power .el-tag+.el-tag {
		margin-left: 10px;
	}
</style>
